import axios from 'axios';
const API_BASE_URL = process.env.VUE_APP_API_URL;
import { vm } from '@/main';

export default class HttpService {

    public async outsideGet(url: string): Promise<any> {
        return await axios(url);
    }

    public async get(url: string, options?: any) {
        try {
            const response = await axios(API_BASE_URL + url, options || this.getOptions());
            return response.data;
        } catch (e) {
            this.notifyError(e);
            if (e.response && e.response.status === 401) {
                try {
                    await this.handle401Error();
                    const response = await axios(API_BASE_URL + url, options || this.getOptions());
                    return response.data;
                } catch (e) {
                    return e;
                }
            }
        }
    }

    public async put(url: string, payload: any, options?: any) {
        try {
            const response = await axios.put(API_BASE_URL + url, payload, options || this.getOptions());
            return response.data;
        } catch (e) {
            this.notifyError(e);
            if (e.response && e.response.status === 401) {
                try {
                    await this.handle401Error();
                    const response = await axios.put(API_BASE_URL + url, payload, options || this.getOptions());
                    return response.data;
                } catch (e) {
                    throw e;
                }
            } else {
                throw e.response;
            }
        }
    }

    public async post(url: string, payload: any, options?: any) {
        try {
            const response = await axios.post(API_BASE_URL + url, payload, options || this.getOptions());
            return response.data;
        } catch (e) {
            this.notifyError(e);
            if (e.response && e.response.status === 401) {
                try {
                    await this.handle401Error();
                    const response = await axios.post(API_BASE_URL + url, payload, options || this.getOptions());
                    return response.data;
                } catch (e) {
                    throw e;
                }
            } else {
                throw e.response;
            }
        }
    }
    public async patch(url: string, payload: any, options?: any) {
        try {
            const response = await axios.patch(API_BASE_URL + url, payload, options || this.getOptions());
            return response.data;
        } catch (e) {
            this.notifyError(e);
            if (e.response && e.response.status === 401) {
                try {
                    await this.handle401Error();
                    const response = await axios.post(API_BASE_URL + url, payload, options || this.getOptions());
                    return response.data;
                } catch (e) {
                    throw e;
                }
            } else {
                throw e.response;
            }
        }
    }
    private getOptions() {
        const token = localStorage.getItem('token');
        if (token) {
            return {
                headers: {
                    Authorization: 'Bearer ' + token,
                },
            };
        }
    }

    private async handle401Error() {
        const refreshToken = localStorage.getItem('refresh_token');
        if (!refreshToken || refreshToken === 'undefined') {
            return;
        } else {
            try {
                const response: any = await axios.post(API_BASE_URL + 'token/refresh', {
                    refresh_token: localStorage.getItem('refresh_token'),
                });
                if (response && response.data && response.data.token && response.data.refresh_token) {
                    localStorage.setItem('token', response.data.token);
                    localStorage.setItem('refresh_token', response.data.refresh_token);
                }
            } catch (e) {
                if (e.response.status === 401) {
                    window.localStorage.removeItem('token');
                    window.localStorage.removeItem('refresh_token');
                }
            }
        }
    }

    private notifyError(e: any) {
        if (e.response.data['hydra:description']) {
            vm.$notify({
                group: 'errors',
                title: 'Error',
                text: e.response.data['hydra:description'],
                type: 'error',
            });
        }
        if (e.response && e.response.data && e.response.data.data && e.response.data.data.message) {
            vm.$notify({
                group: 'errors',
                title: 'Error',
                text: e.response.data.data.message,
                type: 'error',
            });
        }
        if (e.response && e.response.data && e.response.data.message) {
            vm.$notify({
                group: 'errors',
                title: 'Error',
                text: e.response.data.message,
                type: 'error',
            });
        }
    }

}
